export enum ErrorReference {
    kindergelnummerFormat = 'Ein gültige Kindergeldnummer entspricht der Form 123FK123456',
    ordnungkriteriumFormat = 'Das Ordnungskriterium darf keine Freiraumzeichen (Leerstellen, Tabulator etc.) enthalten.',
    kindergelnummerNull = 'Es dürfen nur Zahlen größer als Null eingegeben werden.',
    kindVornameErsteStelle = 'Erste Stelle muss ein Buchstabe sein',
    kindVornameMind2Stelle = 'Mindestens zwei Zeichen',
    kindVornameErlaubteZeichnen = 'Zulässig sind lateinische Groß- und Kleinbuchstaben inklusive Akzente, Bindestrich, Apostroph und Leerzeichen',
    kindGeburtsdatum = 'Das Geburtsdatum des Kindes darf nicht vor dem 01.01.1900 liegen und darf nicht in der Zukunft sein.',
    abfragezeitraum = 'Die Jahreszahl liegt außerhalb des gültigen Bereichs von 1900 bis 2500',
    datumBeginnEnde = 'Das Anfang-Datum muss nach dem Ende-Datum liegen.',
    datumUngueltigJahrMonat = 'Bitte geben Sie das Datum im korrekten Format ein: MM.JJJJ zum Beispiel: #DATE_TODAY',
    datumInFuture = 'Der Abfragezeitraum darf nicht in der Zukunft liegen.',
}
